import { SET_AVATAR } from "../actions/avatar.action";

const initialState = {
    avatarName: "",
    avatarVoice: "",
    avatarImg: "",
    avatarGender: ""
};

export default function avatarReducer(state = initialState, action: any) {
    if (action.type === SET_AVATAR) {
        const avatarObj = JSON.parse(action.avatar);
        return {
            ...state,
            avatarName: avatarObj.name,
            avatarVoice: avatarObj.voice,
            avatarImg: avatarObj.img,
            avatarGender: avatarObj.gender
        }
    }
    return state;
}  